import React, {useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import {TitledBody} from '../../../common/components/TitledBody'
import {Supervisor, SupervisorWithSitesForm} from '../../../app/types'
import {api} from '../../../common/api'
import {useSelector} from 'react-redux'
import {selectedSiteSelector} from '../../../authentication/redux'
import {useHistory} from 'react-router'
import Form, {mapSupervisorToForm} from './Form'
import FormButtons from "../../../common/form/FormButtons";
import SpinnableSubmitButton from "../../../common/form/SpinnableSubmitButton";
import CancelButton from "../../../common/form/CancelButton";

const InitialSupervisor: Supervisor = {
    id: null,
    userId: null,
    userFirstName: null,
    userLastName: null,
    superviseAllSites: true,
    supervisedSites: []
}

export const AddSupervisor = () => {
    const { t } = useTranslation()
    const site = useSelector(selectedSiteSelector)
    const history = useHistory()

    const onSubmit = useCallback(
        async (formData: SupervisorWithSitesForm) => {
            if (!site) return
            await api.post(`/api/site/${site.productId}/business-reporting/supervisors`, {
                supervisorUserId: formData.supervisorUser?.uuid,
                superviseAllSites: formData.superviseAllSites,
                supervisedSiteIds: formData.superviseAllSites ? [] : formData.supervisedSiteIds
            })
            history.push('/business-reporting')
        },
        [site, history],
    )

    const buildFormButtons = useCallback((isSubmitting) =>
            <FormButtons buttons={[<SpinnableSubmitButton label={t('general.form-create')} showSpinner={isSubmitting} />, <CancelButton />]} fullWidth={false} />
        , [t])

    return (
        <TitledBody title={t('supervisors.add.title')}>
            <Form onSubmit={onSubmit} supervisorForm={mapSupervisorToForm(InitialSupervisor)} buildFormButtons={buildFormButtons} />
        </TitledBody>
    )
}
